import InfoDialog from './info-dialog';
export default InfoDialog;
